import React, { useState, useEffect } from "react";
import useDisplay from "../../../hooks/useDisplay";
import styled from "styled-components";

function TextArea(props) {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  return (
    <>
      <TextAreaWrapper
        $isMobile={isMobile}
        value={props.value}
        onChange={props.onChange}
        type={props.type}
        placeholder={props.placeholder}
        style={{
          ...props.style,
        }}
      />
    </>
  );
}

export default TextArea;

const TextAreaWrapper = styled.textarea.attrs((props) => {})`
  width: 100%;
  box-sizing: border-box;

  height: 185px;
  padding: ${(props) => (props.$isMobile ? "10px" : "17px 15px")};

  border-radius: 12px;

  background: #ffffff;
  border: 1px solid #dbdde0;

  font-family: LINESeedKR-Rg;
  font-size: ${(props) => (props.$isMobile ? "12px" : "16px")};
  font-weight: 400;
  color: #101113;

  resize: none;

  &:focus {
    background: #fff;
    outline: 2px solid #5050ff;
  }

  &:disabled {
    outline: none;
    background: #f5f5f5;
    color: #ababab;
  }

  &::placeholder {
    font-family: LINESeedKR-Rg;
    font-size: ${(props) => (props.$isMobile ? "12px" : "16px")};
    font-weight: 400;
    color: #a4a8b1;
  }
`;
